import { Link } from "react-router-dom";

export const CategoryCard = ({ category }) => {
  return (
    <Link
      to={`/shop/${category.slug}`}
      data-testid={`category-card-${category.slug}`}
      className="category-card relative overflow-hidden group"
    >
      <div className="aspect-[4/5] overflow-hidden">
        <img
          src={category.image_url}
          alt={category.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
      <div className="absolute bottom-6 left-6 right-6">
        <h3 className="font-serif text-xl md:text-2xl font-semibold text-white mb-1">
          {category.name}
        </h3>
        <p className="font-sans text-sm text-white/80 hidden md:block">
          {category.description}
        </p>
      </div>
    </Link>
  );
};
